/* 予約プロパティ整合ガード
 * sections/preorder-guard.liquid が出力するズレたラインのJSONを読み、
 * /cart/change.js でプロパティを直す。
 *   mode=inject : 数量>在庫なのに販売種別が無い → 販売種別/お届け予定を再注入
 *   mode=strip  : 実在庫で足りるのに販売種別=予約 → stale予約プロパティを剥がす
 *   mode=refresh: 予約ラインだが焼き付いた お届け予定 が古い → 今の納期に貼り直す
 * 対象経路: カート画面での数量増・同一バリアントの重ね追加・EXPO独自カート投入・
 *           ページ読込時の在庫スナップショットが古いまま投入（stale、注文#1958）・
 *           カート放置やキャッシュ/開きっぱなしタブで納期だけ古いまま（注文#2036）。
 * カート更新(fetch/XHRの /cart/add|change|update)を検知したら
 * ?section_id=preorder-guard で最新のカート状態を再取得して再検査する。
 */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SELECTOR = 'script[data-preorder-cart-guard]';
  var CART_URL = /\/cart\/(add|change|update)/;
  var fixing = false;
  var attempted = {}; // key → true。失敗してもリトライしない（無限ループ防止）

  function parseLines(root) {
    var lines = [];
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      try {
        var arr = JSON.parse(nodes[i].textContent);
        if (Array.isArray(arr)) lines = lines.concat(arr);
      } catch (e) { /* 不正JSONは無視 */ }
    }
    return lines;
  }

  function fixLines(lines) {
    if (fixing) return;
    var todo = null;
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i];
      if (l && l.key && !attempted[l.key]) { todo = l; break; }
    }
    if (!todo) return;
    fixing = true;
    attempted[todo.key] = true;

    // props はLiquidの | json 出力。オブジェクト（{key: value}）と
    // ペア配列（[[key, value], ...]）の両形に対応してマージする。
    var props = {};
    var src = todo.props || {};
    if (Array.isArray(src)) {
      for (var i2 = 0; i2 < src.length; i2++) {
        var pair = src[i2];
        if (pair && pair.length === 2) props[pair[0]] = pair[1];
      }
    } else {
      for (var k in src) {
        if (Object.prototype.hasOwnProperty.call(src, k)) props[k] = src[k];
      }
    }
    var ETA_JA = 'お届け予定';
    var ETA_EN = 'Estimated Delivery';
    if (todo.mode === 'strip') {
      delete props['販売種別'];
      delete props['Type'];
      delete props[ETA_JA];
      delete props[ETA_EN];
    } else if (todo.mode === 'refresh') {
      // 販売種別はそのまま。納期だけ今の値に貼り直す。
      // 既にある方のキー（日本語/英語）を尊重し、無ければ日本語で入れる。
      var etaKey = Object.prototype.hasOwnProperty.call(props, ETA_EN) ? ETA_EN : ETA_JA;
      if (!todo.eta || props[etaKey] === todo.eta) { fixing = false; return; } // 念のため（無駄な書き換え防止）
      props[etaKey] = todo.eta;
    } else {
      props['販売種別'] = '予約';
      if (todo.eta) props[ETA_JA] = todo.eta;
    }

    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: todo.key, quantity: todo.quantity, properties: props })
    }).then(function () {
      fixing = false;
      // プロパティ変更でラインのkeyが変わるため、残りは再取得してから処理する
      scheduleRefresh();
    }, function () {
      fixing = false;
    });
  }

  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch(ROOT + '?section_id=preorder-guard')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          fixLines(parseLines(doc));
        })
        .catch(function () { /* オフライン等は無視。次のカート更新で再試行 */ });
    }, 600);
  }

  // カート更新の検知（fetch）。自前の cart/change もここを通るが、
  // 再取得すると修正済みラインはLiquid側で出力されなくなるので発散しない。
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var p = origFetch.apply(this, arguments);
    if (CART_URL.test(url)) p.then(function () { scheduleRefresh(); }, function () {});
    return p;
  };

  // カート更新の検知（XHR。EXPO等のアプリ経路用）
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_URL.test(String(url))) {
      this.addEventListener('load', scheduleRefresh);
    }
    return origOpen.apply(this, arguments);
  };

  // ページロード時：Liquidが描画済みのインラインデータを検査
  function init() { fixLines(parseLines(document)); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
